import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faMotorcycle,
    faChevronDown,
    faMoneyBillWave,
    faUser,
    faChevronRight,
    faTrash,
    faBasketShopping,
    faHistory,
} from "@fortawesome/free-solid-svg-icons";
import { faClock } from "@fortawesome/free-regular-svg-icons";
import { useEffect, useRef, useState } from "react";
import PrimaryButton from "../components/PrimaryButton";
import axiosInstance from '../axiosConfig';
import { formatValue } from "../utils/formatValue";
import { formatTelefone } from "../utils/formatTelefone";
import Modal from "../components/Modal";
import { useNavigate } from "react-router-dom";
import { playSound } from "../utils/playSound";
import { handleError } from "../services/handleError";
import Loading from "./Loading";

function MeusPedidos() {
    const [secoesAbertas, setSecoesAbertas] = useState({});
    const [pedidos, setPedidos] = useState([]);
    const [isModalCancelOrder, setIsModalCancelOrder] = useState(false);
    const [pedidosPendentes, setPedidosPendentes] = useState([]);
    const [pedidosPreparo, setPedidosPreparo] = useState([]);
    const [pedidosProntos, setPedidosProntos] = useState([]);
    const [loadingPedidos, setLoadingPedidos] = useState({});
    const [loading, setLoading] = useState(true);
    const inputSearchClient = useRef(null);
    const inputSearchOrder = useRef(null);
    const navigate = useNavigate();

    const closeModal = () => {
        setIsModalCancelOrder(false);
    };

    useEffect(() => {
        const fetchPedidos = async () => {
            if (inputSearchClient.current === null && inputSearchOrder.current == null) buscarPedidos();
        };

        fetchPedidos();
        const intervalId = setInterval(fetchPedidos, 30000);
        return () => clearInterval(intervalId);
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (pedidos.length === 0) {
            setPedidosPendentes([]);
            setPedidosPreparo([]);
            setPedidosProntos([]);
        };

        setPedidosPendentes(pedidos.filter(pedido => pedido.status === 1 || pedido.status === "Pendente"));
        setPedidosPreparo(pedidos.filter(pedido => pedido.status === 2 || pedido.status === "EmPreparo"));
        setPedidosProntos(pedidos.filter(pedido => pedido.status === 3 || pedido.status === "Pronto"));
    }, [pedidos]);

    const toggleSecao = (id) => {
        setSecoesAbertas(prevState => ({
            ...prevState,
            [id]: !prevState[id]
        }));
    };

    async function updateStatus(id) {
        if (loadingPedidos[id]) return;

        setLoadingPedidos((prev) => ({ ...prev, [id]: true }));
        setLoading(true);

        try {
            const response = await axiosInstance.put("Pedidos/AvancarStatus/" + id);

            if (response.status === 200) {
                setPedidos((prevPedidos) =>
                    prevPedidos.map((pedido) => {
                        if (pedido.id !== id) return pedido;

                        return {
                            ...pedido,
                            status: response.data,
                        };
                    })
                );
            }
        } catch (error) {
            handleError(error, "Erro ao avançar status pedido.");
        } finally {
            setLoadingPedidos((prev) => ({ ...prev, [id]: false }));
            setLoading(false);
        }
    }

    async function handleCancelOrder() {
        setLoading(true);
        try {
            await axiosInstance.delete("Pedidos/" + isModalCancelOrder);
            setPedidos((prevPedidos) => prevPedidos.filter((pedido) => pedido.id !== isModalCancelOrder));

            setIsModalCancelOrder(false);
        } catch (error) {
            handleError(error, "Erro ao cancelar pedido.");
        } finally {
            setLoading(false);
        }
    };

    let pedidosAnteriores = [];
    async function buscarPedidos(cliente, pedido) {
        try {
            const params = {};

            if (cliente !== "") {
                params.cliente = cliente;
            }

            if (pedido !== "") {
                params.pedido = pedido;
            }

            const response = await axiosInstance.get("Pedidos/PedidosAbertos", { params });

            const novosPedidos = response.data;

            if (novosPedidos.length > pedidosAnteriores.length) {
                const pedidoNovo = novosPedidos.find(
                    pedido => pedido.status === 1 && !pedidosAnteriores.some(p => p.id === pedido.id)
                );

                if (pedidoNovo) {
                    playSound();
                }
            }

            pedidosAnteriores = novosPedidos;

            setPedidos(novosPedidos);
        } catch (error) {
            handleError(error, "Erro ao buscar pedidos.");
        } finally {
            setLoading(false);
        }
    }

    if (loading) {
        return <Loading />;
    }

    return (
        <>
            <Modal isOpen={isModalCancelOrder} onClose={closeModal}>
                <div className="text-black flex justify-between items-center">
                    <span className="text-2xl font-bold">Tem certeza?</span>
                </div>

                <div className="w-full bg-gray-300 my-3" style={{ height: '2px' }} />

                <div className="text-gray-700 leading-relaxed">
                    Você tem certeza que deseja cancelar esse pedido? Essa ação não poderá ser desfeita.
                </div>

                <div className="flex items-center justify-end space-x-2 mt-5">
                    <button
                        onClick={closeModal}
                        className="px-4 py-2 text-gray-600 bg-gray-200 rounded-lg hover:bg-gray-300 transition duration-200"
                    >
                        Cancelar
                    </button>
                    <button
                        onClick={() => handleCancelOrder()}
                        className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition duration-200 shadow-md"
                    >
                        Confirmar
                    </button>
                </div>
            </Modal>


            <div className="p-1 sm:p-5 text-black">
                <div className="mb-3">
                    <div className="flex flex-wrap justify-between">
                        <div className="flex items-center mb-2 w-full sm:w-auto">
                            <PrimaryButton onClick={() => navigate('/historicopedidos')}>
                                <FontAwesomeIcon icon={faHistory} className="mr-2" />
                                Todos os Pedidos
                            </PrimaryButton>
                        </div>
                        <div className="flex space-x-2 w-full sm:w-auto">
                            <PrimaryButton onClick={() => navigate('/novopedido')}>
                                Novo Pedido
                            </PrimaryButton>
                        </div>
                    </div>
                </div>

                <div className="md:flex space-y-2 md:space-y-0 md:space-x-4 items-start">
                    <div className="bg-amber-500 w-full rounded-[10px] p-1 sm:p-2 text-white">
                        <span className="text-xl block text-center">
                            Pedidos Pendentes ({pedidosPendentes.length.toString().padStart(2, '0')})
                        </span>

                        {pedidosPendentes.map(pedido => (
                            <div className="mt-2 rounded-[10px] overflow-hidden">
                                <div className="py-2 sm:py-3 px-2 sm:px-4 bg-amber-700 bg-opacity-35">
                                    <div className="sm:flex space-y-1 sm:space-y-0 justify-between mb-2">
                                        <div className="items-center flex">
                                            <div className="relative flex items-center group" onClick={() => setIsModalCancelOrder(pedido.id)}>
                                                <FontAwesomeIcon
                                                    className="text-md mr-2 rounded-[10px] p-2 bg-red-600 text-white hover:scale-105 cursor-pointer hover:bg-red-700 transition-all duration-300"
                                                    icon={faTrash}
                                                />
                                                <div className="text-center absolute z-50 left-1/2 -translate-x-1/2 top-full mt-2 bg-gray-800  text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                                    Cancelar Pedido
                                                    <div className="absolute left-1/2 -translate-x-1/2 -top-1 border-4 border-transparent border-b-gray-800"></div>
                                                </div>
                                            </div>
                                            <span className="text-md sm:text-lg">Pedido {pedido.id.toString().padStart(6, '0')}#</span>
                                        </div>
                                        <div className="items-center flex space-x-1">
                                            <div className="bg-amber-700 bg-opacity-50 rounded-[10px] py-1 px-2 items-center flex">
                                                <FontAwesomeIcon className="text-lg mr-2" icon={faClock} />
                                                <span className="text-md">{new Date(pedido.dtCriacao).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</span>
                                            </div>
                                            <button className="w-8 py-1 bg-amber-700 bg-opacity-50 rounded-[10px]" onClick={() => toggleSecao(pedido.id)}>
                                                <FontAwesomeIcon icon={faChevronDown} />
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div className={`transition-all duration-500 ease-out overflow-hidden ${secoesAbertas[pedido.id] ? 'h-auto opacity-100 sm:py-3 px-2 sm:px-4 bg-amber-700 bg-opacity-35' : 'h-0 w-0 opacity-100 bg-amber-700 bg-opacity-35'}`}>
                                    {pedido.tipoEntrega === "Retirada" &&
                                        <div className="pb-4">
                                            <div className="bg-amber-700 bg-opacity-50 rounded-[10px] py-1 px-1 sm:px-2 mb-2 items-center flex justify-center">
                                                <FontAwesomeIcon
                                                    className="text-lg mr-2 text-center"
                                                    icon={faUser}
                                                />
                                                Retirada
                                            </div>
                                            <span className="block text-center">{pedido.cliente.nome}: {formatTelefone(pedido.cliente.telefone)}</span>
                                        </div>
                                    }
                                    {pedido.tipoEntrega === "Delivery" &&
                                        <div className="pb-4">
                                            <div className="bg-amber-700 bg-opacity-50 rounded-[10px] py-1 px-1 sm:px-2 mb-2 items-center flex justify-center">
                                                <FontAwesomeIcon
                                                    className="text-lg mr-2 text-center"
                                                    icon={faMotorcycle}
                                                />
                                                Delivery
                                            </div>
                                            <span className="block text-center">{pedido.cliente.nome}: {formatTelefone(pedido.cliente.telefone)}</span>
                                            <span className="block text-center">{pedido.cliente.logradouro}, Nº {pedido.cliente.numero}, {pedido.cliente.bairro}, {pedido.cliente.cidade} - {pedido.cliente.estado}</span>
                                        </div>
                                    }

                                    {pedido.tipoEntrega !== "Balcão" && pedido.formaPagamento !== "Indefinido" && pedido.formaPagamento !== "" &&
                                        <div className="pb-4">
                                            <div className="bg-amber-700 bg-opacity-50 rounded-[10px] py-1 px-2 mb-2 items-center flex justify-center">
                                                <FontAwesomeIcon
                                                    className="text-lg mr-2 text-center"
                                                    icon={faMoneyBillWave}
                                                />
                                                Forma de Pagamento
                                            </div>

                                            <span className="block text-center">
                                                {pedido.formaPagamento === 'Dinheiro' ? (
                                                    pedido.trocoPara ? (
                                                        <>Dinheiro, troco para {formatValue(pedido.trocoPara)}</>
                                                    ) : (
                                                        <>Dinheiro</>
                                                    )
                                                ) : (
                                                    <>Pagamento via {pedido.formaPagamento}</>
                                                )}
                                            </span>
                                        </div>
                                    }

                                    <div className="pb-2 border-amber-700 overflow-hidden items-center space-y-3">
                                        <div className="bg-amber-700 bg-opacity-50 rounded-[10px] py-1 px-2 mb-3 items-center flex justify-center">
                                            <FontAwesomeIcon
                                                className="text-lg mr-2 text-center"
                                                icon={faBasketShopping}
                                            />
                                            Produtos
                                        </div>

                                        {pedido.itensPedido.map(item => (
                                            <div className="flex space-x-4 items-start">
                                                <div className="max-w-16 w-full h-16">
                                                    <img src={item.produto.url_Imagem} alt="Imagem Produto" className="object-cover h-16 w-16 rounded-[10px]" />
                                                </div>
                                                <div className="w-full">
                                                    <div className="flex justify-between">
                                                        <div>
                                                            <span className="text-lg">
                                                                {item.quantidade} {item.produto?.porKg ? "kg" : "un"} - {item.produto?.titulo}
                                                            </span>
                                                        </div>
                                                        <div className="max-w-17">
                                                            <span className="text-lg">{formatValue(item.valorTotal)}</span>
                                                        </div>
                                                    </div>
                                                    {item.listAdicionais.length > 0 && (
                                                        <span className="block text-sm">
                                                            Adicionais: {item.listAdicionais.map(adicional => adicional.nome).join(", ")}
                                                        </span>
                                                    )}
                                                    {item.listPerguntas.length > 0 && (
                                                        <>
                                                            {item.listPerguntas.map((pergunta, idx) => (
                                                                <span key={idx} className="block text-sm">
                                                                    {pergunta.textoPergunta}: {pergunta.textoOpcao}
                                                                </span>
                                                            ))}
                                                        </>
                                                    )}
                                                    {item.observacao !== "" &&
                                                        <span className="text-sm">Obs: {item.observacao}</span>
                                                    }
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                <div className="pb-2 sm:pb-3 px-2 sm:px-4 bg-amber-700 bg-opacity-35">
                                    <div className="flex justify-between">
                                        <div className="items-center sm:flex space-y-1 sm:space-y-0 sm:space-x-2">
                                            <div className="bg-amber-700 bg-opacity-50 rounded-[10px] py-1 px-2 items-center flex">
                                                <FontAwesomeIcon
                                                    className="text-lg mr-2"
                                                    icon={faMoneyBillWave}
                                                />
                                                <span className="text-md">{formatValue(pedido.valorTotal)}</span>
                                            </div>
                                            {pedido.tipoEntrega === "Balcão" &&
                                                <div className="bg-amber-700 bg-opacity-50 rounded-[10px] py-1 px-2 items-center flex">
                                                    <FontAwesomeIcon className="text-lg mr-2" icon={faUser} />
                                                    <span className="text-sm sm:text-md">Mesa {pedido.numeroMesa}</span>
                                                </div>
                                            }
                                            {pedido.tipoEntrega === "Retirada" &&
                                                <div className="bg-amber-700 bg-opacity-50 rounded-[10px] py-1 px-2 items-center flex">
                                                    <FontAwesomeIcon className="text-lg mr-2" icon={faUser} />
                                                    <span className="text-sm sm:text-md">Retirada</span>
                                                </div>
                                            }
                                            {pedido.tipoEntrega === "Delivery" &&
                                                <div className="bg-amber-700 bg-opacity-50 rounded-[10px] py-1 px-2 items-center flex">
                                                    <FontAwesomeIcon className="text-lg mr-2" icon={faUser} />
                                                    <span className="text-sm sm:text-md">Delivery</span>
                                                </div>
                                            }
                                        </div>
                                        <div className="relative items-center flex space-x-1 group">
                                            <button
                                                className="w-8 py-1 bg-blue-700 rounded-[10px] cursor-pointer"
                                                disabled={loadingPedidos[pedido.id]}
                                                onClick={() => updateStatus(pedido.id)}
                                            >
                                                <FontAwesomeIcon icon={faChevronRight} />
                                            </button>
                                            <div className="absolute z-50 left-1/2 -translate-x-[56%] bottom-full mb-2 bg-gray-800 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                                Avançar
                                                <div className="absolute left-1/2 -translate-x-1/2 top-full border-4 border-transparent border-t-gray-800"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="bg-orange-500 w-full rounded-[10px] p-2 text-white">
                        <span className="text-xl block text-center">
                            Pedidos em Preparo ({pedidosPreparo.length.toString().padStart(2, '0')})
                        </span>
                        {pedidosPreparo.map(pedido => (
                            <div className="mt-2 rounded-[10px] overflow-hidden">
                                <div className="py-2 sm:py-3 px-1 sm:px-4 bg-orange-700 bg-opacity-35">
                                    <div className="sm:flex space-y-1 sm:space-y-0 justify-between mb-2">
                                        <div className="items-center flex">
                                            <div className="relative flex items-center group" onClick={() => setIsModalCancelOrder(pedido.id)}>
                                                <FontAwesomeIcon
                                                    className="text-md mr-2 rounded-[10px] p-2 bg-red-600 text-white hover:scale-105 cursor-pointer hover:bg-red-700 transition-all duration-300"
                                                    icon={faTrash}
                                                />
                                                <div className="text-center absolute z-50 left-1/2 -translate-x-1/2 top-full mt-2 bg-gray-800  text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                                    Cancelar Pedido
                                                    <div className="absolute left-1/2 -translate-x-1/2 -top-1 border-4 border-transparent border-b-gray-800"></div>
                                                </div>
                                            </div>
                                            <span className="text-md sm:text-lg">Pedido {pedido.id.toString().padStart(6, '0')}#</span>
                                        </div>
                                        <div className="items-center flex space-x-1">
                                            <div className="bg-orange-700 bg-opacity-50 rounded-[10px] py-1 px-2 items-center flex">
                                                <FontAwesomeIcon className="text-lg mr-2" icon={faClock} />
                                                <span className="text-md">{new Date(pedido.dtCriacao).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</span>
                                            </div>
                                            <button className="w-8 py-1 bg-orange-700 bg-opacity-50 rounded-[10px]" onClick={() => toggleSecao(pedido.id)}>
                                                <FontAwesomeIcon icon={faChevronDown} />
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div className={`transition-all duration-500 ease-out overflow-hidden ${secoesAbertas[pedido.id] ? 'h-auto opacity-100 sm:py-3 px-2 sm:px-4 bg-amber-700 bg-opacity-35' : 'h-0 w-0 opacity-0 bg-amber-700 bg-opacity-35'}`}>
                                    {pedido.tipoEntrega === "Retirada" &&
                                        <div className="pb-4">
                                            <div className="bg-orange-700 bg-opacity-50 rounded-[10px] py-1 px-1 sm:px-2 mb-2 items-center flex justify-center">
                                                <FontAwesomeIcon
                                                    className="text-lg mr-2 text-center"
                                                    icon={faUser}
                                                />
                                                Retirada
                                            </div>
                                            <span className="block text-center">{pedido.cliente.nome}: {formatTelefone(pedido.cliente.telefone)}</span>
                                        </div>
                                    }
                                    {pedido.tipoEntrega === "Delivery" &&
                                        <div className="pb-4">
                                            <div className="bg-orange-700 bg-opacity-50 rounded-[10px] py-1 px-2 mb-2 items-center flex justify-center">
                                                <FontAwesomeIcon
                                                    className="text-lg mr-2 text-center"
                                                    icon={faMotorcycle}
                                                />
                                                Delivery
                                            </div>
                                            <span className="block text-center">{pedido.cliente.nome}: {formatTelefone(pedido.cliente.telefone)}</span>
                                            <span className="block text-center">{pedido.cliente.logradouro}, Nº {pedido.cliente.numero}, {pedido.cliente.bairro}, {pedido.cliente.cidade} - {pedido.cliente.estado}</span>
                                        </div>
                                    }

                                    {pedido.tipoEntrega !== "Balcão" && pedido.formaPagamento !== "Indefinido" && pedido.formaPagamento !== "" &&
                                        <div className="pb-4">
                                            <div className="bg-orange-700 bg-opacity-50 rounded-[10px] py-1 px-2 mb-2 items-center flex justify-center">
                                                <FontAwesomeIcon
                                                    className="text-lg mr-2 text-center"
                                                    icon={faMoneyBillWave}
                                                />
                                                Forma de Pagamento
                                            </div>

                                            <span className="block text-center">
                                                {pedido.formaPagamento === 'Dinheiro' ? (
                                                    pedido.trocoPara ? (
                                                        <>Dinheiro, troco para {formatValue(pedido.trocoPara)}</>
                                                    ) : (
                                                        <>Dinheiro</>
                                                    )
                                                ) : (
                                                    <>Pagamento via {pedido.formaPagamento}</>
                                                )}
                                            </span>
                                        </div>
                                    }

                                    <div className="pb-2 border-orange-700 overflow-hidden items-center space-y-3">
                                        <div className="bg-orange-700 bg-opacity-50 rounded-[10px] py-1 px-2 mb-3 items-center flex justify-center">
                                            <FontAwesomeIcon
                                                className="text-lg mr-2 text-center"
                                                icon={faBasketShopping}
                                            />
                                            Produtos
                                        </div>

                                        {pedido.itensPedido.map(item => (
                                            <div className="flex space-x-4 items-start">
                                                <div className="max-w-16 w-full h-16">
                                                    <img src={item.produto.url_Imagem} alt="Imagem Produto" className="object-cover h-16 w-16 rounded-[10px]" />
                                                </div>
                                                <div className="w-full">
                                                    <div className="flex justify-between">
                                                        <div>
                                                            <span className="text-lg">
                                                                {item.quantidade} {item.produto?.porKg ? "kg" : "un"} - {item.produto?.titulo}
                                                            </span>
                                                        </div>
                                                        <div className="max-w-17">
                                                            <span className="text-lg">{formatValue(item.valorTotal)}</span>
                                                        </div>
                                                    </div>
                                                    {item.listAdicionais.length > 0 && (
                                                        <span className="block text-sm">
                                                            Adicionais: {item.listAdicionais.map(adicional => adicional.nome).join(", ")}
                                                        </span>
                                                    )}
                                                    {item.listPerguntas.length > 0 && (
                                                        <div className="mt-1">
                                                            {item.listPerguntas.map((pergunta, idx) => (
                                                                <span key={idx} className="block text-sm">
                                                                    {pergunta.textoPergunta}: {pergunta.textoOpcao}
                                                                </span>
                                                            ))}
                                                        </div>
                                                    )}
                                                    {item.observacao !== "" &&
                                                        <span className="text-sm">Obs: {item.observacao}</span>
                                                    }
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                <div className="pb-2 sm:pb-3 px-2 sm:px-4 bg-orange-700 bg-opacity-35">
                                    <div className="flex justify-between">
                                        <div className="items-center sm:flex space-y-1 sm:space-y-0 sm:space-x-2">
                                            <div className="bg-orange-700 bg-opacity-50 rounded-[10px] py-1 px-2 items-center flex">
                                                <FontAwesomeIcon
                                                    className="text-lg mr-2"
                                                    icon={faMoneyBillWave}
                                                />
                                                <span className="text-md">{formatValue(pedido.valorTotal)}</span>
                                            </div>
                                            {pedido.tipoEntrega === "Balcão" &&
                                                <div className="bg-orange-700 bg-opacity-50 rounded-[10px] py-1 px-2 items-center flex">
                                                    <FontAwesomeIcon className="text-lg mr-2" icon={faUser} />
                                                    <span className="text-sm sm:text-md">Mesa {pedido.numeroMesa}</span>
                                                </div>
                                            }
                                            {pedido.tipoEntrega === "Retirada" &&
                                                <div className="bg-orange-700 bg-opacity-50 rounded-[10px] py-1 px-2 items-center flex">
                                                    <FontAwesomeIcon className="text-lg mr-2" icon={faUser} />
                                                    <span className="text-sm sm:text-md">Retirada</span>
                                                </div>
                                            }
                                            {pedido.tipoEntrega === "Delivery" &&
                                                <div className="bg-orange-700 bg-opacity-50 rounded-[10px] py-1 px-2 items-center flex">
                                                    <FontAwesomeIcon className="text-lg mr-2" icon={faUser} />
                                                    <span className="text-sm sm:text-md">Delivery</span>
                                                </div>
                                            }
                                        </div>
                                        <div className="relative items-center flex space-x-1 group">
                                            <button
                                                className="w-8 py-1 bg-blue-700 rounded-[10px] cursor-pointer"
                                                disabled={loadingPedidos[pedido.id]}
                                                onClick={() => updateStatus(pedido.id)}
                                            >
                                                <FontAwesomeIcon icon={faChevronRight} />
                                            </button>
                                            <div className="absolute z-50 left-1/2 -translate-x-[56%] bottom-full mb-2 bg-gray-800 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                                Avançar
                                                <div className="absolute left-1/2 -translate-x-1/2 top-full border-4 border-transparent border-t-gray-800"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}

                    </div>
                    <div className="bg-green-700 w-full rounded-[10px] p-2 text-white">
                        <span className="text-xl block text-center">
                            Pedidos Prontos ({pedidosProntos.length.toString().padStart(2, '0')})
                        </span>
                        {pedidosProntos.map(pedido => (
                            <div className="mt-2 rounded-[10px] overflow-hidden">
                                <div className="py-2 sm:py-3 px-1 sm:px-4 bg-green-900 bg-opacity-35">
                                    <div className="sm:flex space-y-1 sm:space-y-0 justify-between mb-2">
                                        <div className="items-center flex">
                                            <div className="relative flex items-center group" onClick={() => setIsModalCancelOrder(pedido.id)}>
                                                <FontAwesomeIcon
                                                    className="text-md mr-2 rounded-[10px] p-2 bg-red-600 text-white hover:scale-105 cursor-pointer hover:bg-red-700 transition-all duration-300"
                                                    icon={faTrash}
                                                />
                                                <div className="text-center absolute z-50 left-1/2 -translate-x-1/2 top-full mt-2 bg-gray-800  text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                                    Cancelar Pedido
                                                    <div className="absolute left-1/2 -translate-x-1/2 -top-1 border-4 border-transparent border-b-gray-800"></div>
                                                </div>
                                            </div>
                                            <span className="text-md sm:text-lg">Pedido {pedido.id.toString().padStart(6, '0')}#</span>
                                        </div>
                                        <div className="items-center flex space-x-1">
                                            <div className="bg-green-900 bg-opacity-50 rounded-[10px] py-1 px-2 items-center flex">
                                                <FontAwesomeIcon className="text-lg mr-2" icon={faClock} />
                                                <span className="text-md">{new Date(pedido.dtCriacao).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</span>
                                            </div>
                                            <button className="w-8 py-1 bg-green-900 bg-opacity-50 rounded-[10px]" onClick={() => toggleSecao(pedido.id)}>
                                                <FontAwesomeIcon icon={faChevronDown} />
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div className={`transition-all duration-500 ease-out overflow-hidden ${secoesAbertas[pedido.id] ? 'h-auto opacity-100 sm:py-3 px-2 sm:px-4 bg-green-900 bg-opacity-35' : 'h-0 w-0 opacity-0 bg-green-900 bg-opacity-35'}`}>
                                    {pedido.tipoEntrega === "Retirada" &&
                                        <div className="pb-4">
                                            <div className="bg-green-900 bg-opacity-50 rounded-[10px] py-1 px-1 sm:px-2 mb-2 items-center flex justify-center">
                                                <FontAwesomeIcon
                                                    className="text-lg mr-2 text-center"
                                                    icon={faUser}
                                                />
                                                Retirada
                                            </div>
                                            <span className="block text-center">{pedido.cliente.nome}: {formatTelefone(pedido.cliente.telefone)}</span>
                                        </div>
                                    }
                                    {pedido.tipoEntrega === "Delivery" &&
                                        <div className="pb-4">
                                            <div className="bg-green-900 bg-opacity-50 rounded-[10px] py-1 px-2 mb-2 items-center flex justify-center">
                                                <FontAwesomeIcon
                                                    className="text-lg mr-2 text-center"
                                                    icon={faUser}
                                                />
                                                Delivery
                                            </div>
                                            <span className="block text-center">{pedido.cliente.nome}: {formatTelefone(pedido.cliente.telefone)}</span>
                                            <span className="block text-center">{pedido.cliente.logradouro}, Nº {pedido.cliente.numero}, {pedido.cliente.bairro}, {pedido.cliente.cidade} - {pedido.cliente.estado}</span>
                                        </div>
                                    }

                                    {pedido.tipoEntrega !== "Balcão" && pedido.formaPagamento !== "Indefinido" && pedido.formaPagamento !== "" &&
                                        <div className="pb-4">
                                            <div className="bg-green-900 bg-opacity-50 rounded-[10px] py-1 px-2 mb-2 items-center flex justify-center">
                                                <FontAwesomeIcon
                                                    className="text-lg mr-2 text-center"
                                                    icon={faMoneyBillWave}
                                                />
                                                Forma de Pagamento
                                            </div>

                                            <span className="block text-center">
                                                {pedido.formaPagamento === 'Dinheiro' ? (
                                                    pedido.trocoPara ? (
                                                        <>Dinheiro, troco para {formatValue(pedido.trocoPara)}</>
                                                    ) : (
                                                        <>Dinheiro</>
                                                    )
                                                ) : (
                                                    <>Pagamento via {pedido.formaPagamento}</>
                                                )}
                                            </span>
                                        </div>
                                    }

                                    <div className="pb-2 border-green-900 overflow-hidden items-center space-y-3">
                                        <div className="bg-green-900 bg-opacity-50 rounded-[10px] py-1 px-2 mb-3 items-center flex justify-center">
                                            <FontAwesomeIcon
                                                className="text-lg mr-2 text-center"
                                                icon={faBasketShopping}
                                            />
                                            Produtos
                                        </div>

                                        {pedido.itensPedido.map(item => (
                                            <div className="flex space-x-4 items-start">
                                                <div className="max-w-16 w-full h-16">
                                                    <img src={item.produto.url_Imagem} alt="Imagem Produto" className="object-cover h-16 w-16 rounded-[10px]" />
                                                </div>
                                                <div className="w-full">
                                                    <div className="flex justify-between">
                                                        <div>
                                                            <span className="text-lg">
                                                                {item.quantidade} {item.produto?.porKg ? "kg" : "un"} - {item.produto?.titulo}
                                                            </span>
                                                        </div>
                                                        <div className="max-w-17">
                                                            <span className="text-lg">{formatValue(item.valorTotal)}</span>
                                                        </div>
                                                    </div>
                                                    {item.listAdicionais.length > 0 && (
                                                        <span className="block text-sm">
                                                            Adicionais: {item.listAdicionais.map(adicional => adicional.nome).join(", ")}
                                                        </span>
                                                    )}
                                                    {item.listPerguntas.length > 0 && (
                                                        <div className="mt-1">
                                                            {item.listPerguntas.map((pergunta, idx) => (
                                                                <span key={idx} className="block text-sm">
                                                                    {pergunta.textoPergunta}: {pergunta.textoOpcao}
                                                                </span>
                                                            ))}
                                                        </div>
                                                    )}
                                                    {item.observacao !== "" &&
                                                        <span className="text-sm">Obs: {item.observacao}</span>
                                                    }
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                <div className="pb-2 sm:pb-3 px-2 sm:px-4 bg-green-900 bg-opacity-35">
                                    <div className="flex justify-between">
                                        <div className="items-center sm:flex space-y-1 sm:space-y-0 sm:space-x-2">
                                            <div className="bg-green-900 bg-opacity-50 rounded-[10px] py-1 px-2 items-center flex">
                                                <FontAwesomeIcon
                                                    className="text-lg mr-2"
                                                    icon={faMoneyBillWave}
                                                />
                                                <span className="text-md">{formatValue(pedido.valorTotal)}</span>
                                            </div>
                                            {pedido.tipoEntrega === "Balcão" &&
                                                <div className="bg-green-900 bg-opacity-50 rounded-[10px] py-1 px-2 items-center flex">
                                                    <FontAwesomeIcon className="text-lg mr-2" icon={faUser} />
                                                    <span className="text-sm sm:text-md">Mesa {pedido.numeroMesa}</span>
                                                </div>
                                            }
                                            {pedido.tipoEntrega === "Retirada" &&
                                                <div className="bg-green-900 bg-opacity-50 rounded-[10px] py-1 px-2 items-center flex">
                                                    <FontAwesomeIcon className="text-lg mr-2" icon={faUser} />
                                                    <span className="text-sm sm:text-md">Retirada</span>
                                                </div>
                                            }
                                            {pedido.tipoEntrega === "Delivery" &&
                                                <div className="bg-green-900 bg-opacity-50 rounded-[10px] py-1 px-2 items-center flex">
                                                    <FontAwesomeIcon className="text-lg mr-2" icon={faUser} />
                                                    <span className="text-sm sm:text-md">Delivery</span>
                                                </div>
                                            }
                                        </div>
                                        <div className="relative items-center flex space-x-1 group">
                                            <button
                                                className="w-8 py-1 bg-blue-700 rounded-[10px] cursor-pointer"
                                                disabled={loadingPedidos[pedido.id]}
                                                onClick={() => updateStatus(pedido.id)}
                                            >
                                                <FontAwesomeIcon icon={faChevronRight} />
                                            </button>
                                            <div className="absolute z-50 left-1/2 -translate-x-[56%] bottom-full mb-2 bg-gray-800 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                                Avançar
                                                <div className="absolute left-1/2 -translate-x-1/2 top-full border-4 border-transparent border-t-gray-800"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
}

export default MeusPedidos;
